export default {
      id: "bell-icon-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#bell-icon",
      toString: function () {
        return this.url;
      }
    }